const REACT_INVALID_TICKET_IDS = ['16889', '16869', '16888', '16870', '16871'];

export const hasInvalidTicket = ({ticketTraits, showUKCMAFeatures}) =>
  ticketTraits.some(({id}) => showUKCMAFeatures && REACT_INVALID_TICKET_IDS && REACT_INVALID_TICKET_IDS.includes(id));
